import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class EmbarqueEquipeService {
  private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getEmbarqueEquipes() {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/embarqueequipe')
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getEmbarqueEquipe(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/embarqueequipe/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaEmbarqueEquipe(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/embarqueequipe', {
				cliente_id: data.cliente_id,
				unidade_id: data.unidade_id,
				profissional_id: data.profissional_id,
				veiculo_id: data.veiculo_id,
				usuario_id: data.usuario_id,
				embarque_equipe_data: data.embarque_equipe_data,
				embarque_equipe_turno: data.embarque_equipe_turno,
				embarque_equipe_registro: data.embarque_equipe_registro ,
				embarque_equipe_deletado: data.embarque_equipe_deletado ,
				embarque_equipe_status: data.embarque_equipe_status ,
				embarque_equipe_justificativa: data.embarque_equipe_justificativa ,
				equipe_id: data.equipe_id,
				profissionais: data.profissionais
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	

	editaEmbarqueEquipe(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/embarqueequipe/' + data.embarque_equipe_id, {
				cliente_id: data.cliente_id,
				unidade_id: data.unidade_id,
				profissional_id: data.profissional_id,
				veiculo_id: data.veiculo_id,
				usuario_id: data.usuario_id,
				embarque_equipe_data: data.embarque_equipe_data,
				embarque_equipe_turno: data.embarque_equipe_turno,
				embarque_equipe_registro: data.embarque_equipe_registro ,
				embarque_equipe_deletado: data.embarque_equipe_deletado ,
				embarque_equipe_status: data.embarque_equipe_status ,
				embarque_equipe_justificativa: data.embarque_equipe_justificativa ,
				equipe_id: data.equipe_id,
				profissionais: data.profissionais
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaEmbarqueEquipe(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/embarqueequipe/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
	
	apagaEmbarqueEquipeAdmin(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/embarqueequipe/admin/' + id)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}

	getEmbarqueEquipesByUsuarioQtde(usuario_id, filtro) {
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/embarqueequipe/embarque_qtde/' + usuario_id + params)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}	


	getEmbarqueEquipesByRegiaoQtde(usuario_id, filtro) {
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/embarqueequipe/regiao_qtde/' + usuario_id + params)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}	

	getEmbarqueEquipesByUsuario(id, filtro={}, pagina=1) {

		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/embarqueequipe/usuario/' + id + '/' + pagina + params)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


	getEmbarqueEquipesByRegiao(id, filtro={}, pagina=1) {

		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/embarqueequipe/regiao/' + id + '/' + pagina + params)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getEmbarqueEquipesByExcel(usuario_id, filtro, ultimo_id) {
		let qtde = 500;
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/embarqueequipe/usuario_excel/' + usuario_id + '/' + ultimo_id + '/' + qtde + params)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}	


	getEmbarqueEquipesByExcelRegiao(usuario_id, filtro, ultimo_id) {
		let qtde = 500;
		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');
				if (aux[1] == 'data_i' || aux[1] == 'data_f')
					val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/embarqueequipe/regiao_excel/' + usuario_id + '/' + ultimo_id + '/' + qtde + params)
				.map(res => res.json())
				.subscribe(data => {
					this.data = data;
					resolve(this.data);
				},
					err => {
						reject(err);
					});
		});
	}	

	fechaTurno(id) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/embarqueequipe/' + id, {
				embarque_equipe_status: 'F',
				embarque_equipe_fim_turno: moment().format('YYYY-MM-DD HH:mm:ss')
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


	getBuscaProfissionais(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/embarqueequipe/busca_profissionais/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getBuscaProfissionaisEquipeCad(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/embarqueequipe/busca_profissionais_cad/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getBuscaTipoProfissionalEquipe(id){
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/embarqueequipe/buscaTipoProfissionalEquipe/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});	
	}

	getBuscaProfissionaisPorEquipe(equipe_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/embarqueequipe/buscaProfissionalPorEquipe/' + equipe_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}	
}
